// extracted by mini-css-extract-plugin
module.exports = {"body":"layout_body__1qGmA","navBar":"layout_navBar__1PyXa"};